// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WifiBoxAdd_wrapper__2fT_g","contentWrapper":"WifiBoxAdd_contentWrapper__1hJM5"};